module.exports = __webpack_public_path__ + "static/media/dsp-logo.96a67cd1.svg";